import React from 'react'
import style from './PendingStores.css'

export const PendingStores = ({ storesPending }) => (
    <div className="panel panel-warning">
        <div className="panel-heading">Locales con inventarios cercanos y con stock desactualizado
            <span className="pull-right glyphicon glyphicon-warning-sign"/>
        </div>
        <div className={`panel-body ${style.PendingStores_panelBody}`}>
            <div className="table-responsive">
                <table className={`table table-striped table-hover ${style.PendingStores_table}`}>
                    <thead>
                    <tr>
                        <th className={style.PendingStores_thIndex}>#</th>
                        <th>CECO</th>
                        <th>Local</th>
                        <th>Comuna</th>
                        <th className={style.PendingStores_thAddress}>Dirección</th>
                        <th>Stock</th>
                        <th>Fecha Stock</th>
                        <th>Próximo Inventario</th>
                    </tr>
                    </thead>
                    <tbody>
                    {storesPending.length === 0? <tr><td colSpan="8" style={{textAlign: 'center'}}>No se encontraron registros</td></tr> : null}
                    {storesPending.map((data, index) => {
                        return(
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td className={style.PendingStores_tdNumbers}>{data.store_ceco}</td>
                                <td>{data.store_name}</td>
                                <td>{data.store_comuna}</td>
                                <td>{data.store_address}</td>
                                <td className={style.PendingStores_tdNumbers}>{data.inventory_stock.toLocaleString("es-CL")}</td>
                                <td>{data.inventory_stock_date}</td>
                                <td>{data.inventory_date}</td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./frontEnd/admin/stockStoreUpdate/components/PendingStores.jsx